var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import * as React from 'react';
import { cn } from '../lib/utils';
var Table = React.forwardRef(function (_a, ref) {
    var className = _a.className, props = __rest(_a, ["className"]);
    return (_jsx("table", __assign({ ref: ref, className: cn('w-full text-sm border-separate border-spacing-0', className) }, props)));
});
Table.displayName = 'Table';
var TableHeader = React.forwardRef(function (_a, ref) {
    var className = _a.className, props = __rest(_a, ["className"]);
    return (_jsx("thead", __assign({ ref: ref, className: cn('z-10', className) }, props)));
});
TableHeader.displayName = 'TableHeader';
var TableBody = React.forwardRef(function (_a, ref) {
    var className = _a.className, props = __rest(_a, ["className"]);
    return (_jsx("tbody", __assign({ ref: ref, className: className }, props)));
});
TableBody.displayName = 'TableBody';
var TableRow = React.forwardRef(function (_a, ref) {
    var className = _a.className, props = __rest(_a, ["className"]);
    return (_jsx("tr", __assign({ ref: ref, className: cn('transition-colors hover:bg-muted/50', className) }, props)));
});
TableRow.displayName = 'TableRow';
var TableHead = React.forwardRef(function (_a, ref) {
    var className = _a.className, props = __rest(_a, ["className"]);
    return (_jsx("th", __assign({ ref: ref, className: cn('px-2 py-2 text-[10px] leading-[12px] text-left font-medium uppercase tracking-[1px] text-muted-foreground border-t border-b border-border align-middle [&:has([role=checkbox])]:pr-0 bg-background', className) }, props)));
});
TableHead.displayName = 'TableHead';
var TableCell = React.forwardRef(function (_a, ref) {
    var className = _a.className, props = __rest(_a, ["className"]);
    return (_jsx("td", __assign({ ref: ref, className: cn('px-2 py-[18px] align-middle border-b border-border [&:has([role=checkbox])]:pr-0', className) }, props)));
});
TableCell.displayName = 'TableCell';
export { Table, TableHeader, TableBody, TableRow, TableHead, TableCell };
